import type { Chat } from '../Contracts'

export interface ChatSection {
    key: string
    label: string
    match: (chat: Chat) => boolean
}

/**
 * Розділи списку чатів. Data-driven: чат несе type + entityType, тож
 * розділ — чиста клієнтська фільтрація. Чати нової сутності (машини,
 * маршрути, …) підключаються одним записом тут — даних уже достатньо.
 */
export const CHAT_SECTIONS: ChatSection[] = [
    { key: 'all', label: 'Усі', match: () => true },
    { key: 'private', label: 'Особисті', match: (chat) => chat.type === 'private' },
    { key: 'group', label: 'Групи', match: (chat) => chat.type === 'group' && !chat.entityType },
    { key: 'transport_request', label: 'Заявки', match: (chat) => chat.entityType === 'transport_request' },
]
